import React from 'react';
import styled from 'styled-components';

import useAudience from 'hooks/useAudience';
import { useContextId } from 'hooks/useSessionVariables';
import { useLoginContext } from '../login-context';
import TourDatePicker from 'pages/showing/components/tour-date-picker';
import { getToursSettingsInfo } from 'pages/showing/components/tour-date-picker';

const Wrapper = styled.div`
  margin: 0 0 40px 0;
`;

const Title = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 1.5em;
`;

export default () => {
  const [audience] = useAudience();
  const contextId = useContextId();
  const { location, dataFetched } = useLoginContext();
  const [tourDate, setTourDate] = React.useState(() => {
    const params = new URLSearchParams(window.location.search);
    const urlDate = params.get('tourDate');
    if (urlDate && !isNaN(new Date(urlDate).getTime())) {
      sessionStorage.setItem('selectedTourDate', new Date(urlDate).toISOString());
      return new Date(urlDate);
    }
    const storedDate = sessionStorage.getItem('selectedTourDate');
    return storedDate ? new Date(storedDate) : '';
  });

  const handleDateChange = (date) => {
    setTourDate(date);
    if (date) {
      sessionStorage.setItem('selectedTourDate', date instanceof Date ? date.toISOString() : date);
    } else {
      sessionStorage.removeItem('selectedTourDate');
    }
  };

  if (audience?.uuid !== 'showing' || !contextId || !dataFetched || !location) {
    return null;
  }

  const { isTimePickerVisible } = getToursSettingsInfo(location);
  if (!isTimePickerVisible) return null;

  return (
    <Wrapper>
      <Title>Pick a tour date and time</Title>
      <TourDatePicker location={location} value={tourDate} onChange={handleDateChange} />
    </Wrapper>
  );
};
